import { render, staticRenderFns } from "./pagination-quarternary.vue?vue&type=template&id=d01c9196&scoped=true"
import script from "./pagination-quarternary.vue?vue&type=script&lang=js"
export * from "./pagination-quarternary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d01c9196",
  null
  
)

export default component.exports